import React from 'react'

import { ZariContext } from '_zari/context'

import { Modal, Table, Button } from '_zari/core'

import * as OrdenCompraService from 'services/ordenCompra.service'

const ListaOrdenesModal = ({
  show,
  handleClose,
  idSocio,
  toggleInfoOrdenModal,
  idTemporalOrdenCompraRef,
  flagVerOrdenesCerradas
}) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaOrdenes, setListaOrdenes] = React.useState([])

  React.useEffect(() => {
    // paraIngresoAlmacen=true: incluye OCs provisionadas (la provisión contable es
    // independiente del ingreso físico al almacén).
    OrdenCompraService.getOrdenes_ParaCompra({
      idSocio,
      flagVerOrdenesCerradas,
      paraIngresoAlmacen: true
    })
      .then(({ data }) => {
        setListaOrdenes(data)
      })
      .catch(() => {
        __zariContext.snack('error', 'No se pudo obtener las ordenes de compra.')
      })
  }, [__zariContext, idSocio, flagVerOrdenesCerradas])

  const clickSeleccionar = React.useCallback(
    id => {
      idTemporalOrdenCompraRef.current = id
      handleClose()
      toggleInfoOrdenModal()
    },
    [handleClose, idTemporalOrdenCompraRef, toggleInfoOrdenModal]
  )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>LISTA ORDENES</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          maxRowsShown={6}
          filas={listaOrdenes}
          headRows={[{ label: 'FECHA' }, { label: 'GLOSA' }, { label: 'SERIE-NUMERO' }, { label: '' }]}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.glosa || '--'}</Table.Cell>
              <Table.Cell>{`${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
              <Table.Cell>
                <Button onClick={e => clickSeleccionar(row._id)}>
                  {flagVerOrdenesCerradas ? 'Ver detalles' : 'Seleccionar'}
                </Button>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ListaOrdenesModal
